import { Component, OnInit } from '@angular/core';
import { NavParams } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';

@Component({
  selector: 'app-delegasi-pindah-modal',
  templateUrl: './delegasi-pindah-modal.component.html',
  styleUrls: ['./delegasi-pindah-modal.component.css'],
})
export class DelegasiPindahModalComponent implements OnInit {
  kw: any;
  load = false;
  hasilX: any = {};
  group = '';
  nama: any = '';
  kelompok: any = '';

  constructor(
    public navParams: NavParams,
    public api: ApiService,
    public util: UtilService
  ) {
    try {
      this.kw = JSON.parse(this.navParams.data.id);
    } catch (error) {
      this.util.showToast('Data Lead_id tidak terparsing', 'danger', 'bottom');
      this.kw = [];
    }

    this.kelompok = this.navParams.data.kelompok || '';
    this.nama = this.navParams.data.nama || '';
  }

  ngOnInit(): void {}

  handleSelection(selectedValue: string) {
    this.group = selectedValue;
  }

  submit() {
    if (this.load) {
      return;
    }
    if (!this.group) {
      this.util.showToast('Group Wajib Diisi', 'danger', 'bottom');
      return;
    }

    this.load = true;
    const param = {
      new_group: false,
      lead_id: this.kw,
      move_group_to: this.group,
    };

    this.api.put('backoffice/delegasi/pindah-kelompok', param).subscribe(
      (data) => {
        this.hasilX = data;
        this.load = false;
        this.util.showToast(this.hasilX.message, 'success', 'bottom');
        this.api.dismissData('', 'confirm');
      },
      (error) => {
        this.load = false;
        this.api.errorCond(error);
      }
    );
  }

  batal() {
    this.api.dismiss();
  }
}
